import styled from "styled-components";

export const ContainerStatementContent = styled.div`
  max-width: 81rem;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  height: auto;

  .search {
    display: flex;
    justify-content: space-between;
    margin-top: 1.5rem;
    gap: 0.5rem;

    position: relative;
  }

  .chart {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  @media screen and (max-width: 1099px) {
    width: 100%;
  }
`;

export const TagSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1400px) {
    flex-wrap: wrap;
  }
`;
